import React, { useEffect } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { Hero } from './components/Hero';
import { ForYou } from './components/ForYou';
import { Transformation } from './components/Transformation';
import { WhatYouLearn } from './components/WhatYouLearn';
import { Testimonials } from './components/Testimonials';
import { BonusStack } from './components/BonusStack';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel, trackEvent } from './components/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackEvent('PageView');
  }, []);
  return <div className="min-h-screen bg-white font-inter selection:bg-bordeaux selection:text-white" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ForYou data-id="element-4" />
        <Transformation data-id="element-5" />
        <WhatYouLearn data-id="element-6" />

        <Testimonials data-id="element-7" />
        <BonusStack data-id="element-8" />
        <Guarantee data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}